export async function withRetry(fn, { retries = 3, baseDelayMs = 3000, maxDelayMs = 30000, onRetry } = {}) {
  let lastError
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await fn(attempt)
    } catch (error) {
      lastError = error
      if (attempt === retries) break
      onRetry?.(attempt + 1, error)
      const delay = Math.min(baseDelayMs * 2 ** attempt, maxDelayMs)
      await new Promise(resolve => setTimeout(resolve, delay))
    }
  }
  throw lastError
}
